import React from "react";
import { Box } from "@mui/material";

export default function PIInfoRow({ left, right }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        mx: "auto",
        minHeight: "40px",
        py: 0.5,
        borderRight: "1px solid #cdcdcd",
        borderLeft: "1px solid #cdcdcd",
        borderBottom: "1px solid #cdcdcd",
      }}
    >
      <Box sx={{ width: "50%", borderRight: "1px solid #F3F2F3", pl: 1 }}>
        {left}
      </Box>
      <Box sx={{ width: "50%", pl: 1 }}>
        {right}
      </Box>
    </Box>
  );
}
